export enum Category {
  KETAB_EBTEDAEI = 1,
  KETAB_MOTEVASET_AVAL = 2,
  KETAB_MOTEVASET_DOVOM = 3,
  KONKOUR = 4,
  TIZHOUSHAN = 25,
  EMTEHAN_NAHAEI = 30,
}
